
import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Lock, Play } from "lucide-react";
import { Module } from "@/types/course";

interface ModulesSectionProps {
  modules: Module[];
}

export const ModulesSection: React.FC<ModulesSectionProps> = ({ modules }) => {
  if (!modules || modules.length === 0) {
    return (
      <section className="py-6" id="curriculum">
        <h2 className="text-2xl font-bold mb-6">Course Curriculum</h2>
        <p className="text-muted-foreground">No curriculum available for this course.</p>
      </section>
    );
  }

  // Sort modules by their order property
  const sortedModules = [...modules].sort((a, b) => a.order - b.order);

  return (
    <section className="py-6" id="curriculum">
      <h2 className="text-2xl font-bold mb-6">Course Curriculum</h2>
      
      <Accordion type="single" collapsible className="w-full">
        {sortedModules.map((module) => (
          <AccordionItem key={module.id} value={module.id}>
            <AccordionTrigger className="text-lg font-medium">
              {module.title}
            </AccordionTrigger>
            <AccordionContent>
              <ul className="space-y-2">
                {module.lessons?.map((lesson) => (
                  <li key={lesson.id} className="p-3 border rounded-md flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      {lesson.is_preview ? (
                        <Play className="h-4 w-4 text-primary" />
                      ) : (
                        <Lock className="h-4 w-4 text-muted-foreground" />
                      )}
                      <span>{lesson.title}</span>
                    </div>
                    {lesson.is_preview && (
                      <Badge variant="secondary">Preview</Badge>
                    )}
                  </li>
                ))}
                
                {(!module.lessons || module.lessons.length === 0) && (
                  <li className="p-3 text-muted-foreground">
                    No lessons available in this module.
                  </li>
                )}
              </ul>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
